import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { logger } from '@fiverr-private/obs';
import { Divider, Stack } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { invokeSkillsList, useSellerData, FederatedSeller } from '@fiverr-private/seller_pages_toolbox';
import { ExpertiseList } from './ExpertiseList/ExpertiseList';

const onRenderError = (originalError) => {
    const err = new Error(`Failed while rendering the Expertise Component`);
    logger.error(err, {
        cause: originalError,
    });
};

export const Expertise = () => {
    const { gigCategories, proSubCategories, activeStructuredSkills } = useSellerData(selectSellerSlice);

    const items = useMemo(
        () =>
            invokeSkillsList({
                proSubCategories,
                gigCategories,
                skills: activeStructuredSkills,
                filter: 'only_skills',
            }),
        [proSubCategories, gigCategories, activeStructuredSkills]
    );

    if (isEmpty(items)) {
        return null;
    }

    return (
        <ErrorBoundary onError={onRenderError}>
            <Divider />
            <Stack direction="column" gap="0">
                <Typography size={{ default: 'h_sm', lg: 'h_md' }} marginBottom="3" fontWeight="bold" color="grey_1200">
                    {translate('seller_page_perseus.professions_page.main_content.expertise')}
                </Typography>
                <ExpertiseList items={items} />
            </Stack>
        </ErrorBoundary>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        gigCategories: seller.gigCategories,
        proSubCategories: seller.proSubCategories,
        activeStructuredSkills: seller.activeStructuredSkills,
    };
}
